import { render, staticRenderFns } from "./ListFakturPage.vue?vue&type=template&id=f051e7a8&"
import script from "./ListFakturPage.vue?vue&type=script&lang=js&"
export * from "./ListFakturPage.vue?vue&type=script&lang=js&"
import style0 from "./ListFakturPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports